const withDateRange = d =>
  Object.assign({}, d, {
    dailyWeather: d.dailyWeather.slice(d.depIndex, d.retIndex)
  });

const withDateIndexes = (d, departureDate, returnDate) =>
  Object.assign({}, d, {
    depIndex: d.dailyWeather.findIndex(w => w.date === departureDate),
    retIndex: d.dailyWeather.findIndex(w => w.date === returnDate) + 1
  });

const withAvgs = d => {
  const { dailyWeather } = d;
  return Object.assign({}, d, {
    maxHigh: dailyWeather.reduce((max, next) => {
      const nextMax = next.temp.max;
      if (nextMax > max) return nextMax;
      return max;
    }, -Infinity),
    minLow: dailyWeather.reduce((min, next) => {
      const nextMin = next.temp.min;
      if (nextMin < min) return nextMin;
      return min;
    }, Infinity),
    numSunDays: dailyWeather.reduce((num, next) => {
      const descr = next.weather[0].description;
      if (descr === 'sky is clear' || descr === 'few clouds') {
        return num + 1;
      }
      return num;
    }, 0),
    numClearDays: dailyWeather.reduce((num, next) => {
      const descr = next.weather[0].description;
      if (descr === 'sky is clear') {
        return num + 1;
      }
      return num;
    }, 0),
    numRainDays: dailyWeather.reduce((num, next) => {
      if (next.rain) {
        return num + 1;
      }
      return num;
    }, 0),
    avgTemp:
      dailyWeather.reduce((total, next) => {
        return total + next.temp.max;
      }, 0) / dailyWeather.length,
    hasHighHumidity: dailyWeather[2].humidity && dailyWeather[2].humidity > 80
  });
};

module.exports = {
  withDateIndexes,
  withDateRange,
  withAvgs
};



// WEBPACK FOOTER //
// ./src/utils/openWeatherUtils.js